"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createActor;

var _normalized = require("./normalized");

function createActor(schema, dispatch, groupBys) {
  var actor = (0, _normalized.actor)(schema, dispatch);
  groupBys.forEach(function (groupBy) {
    actor[groupBy.name] = groupBy.getActor(dispatch);
  });
  return actor;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/createActor.js
// module id = 1352
// module chunks = 2